"use strict";

exports.__esModule = true;
exports.setTokens = exports.refreshToken = exports.getCookie = exports.encodeData = exports.clearTokens = void 0;
var _cookie = require("@tajawal/web-core-sdk-v2/lib/services/cookie.service");
var _nookies = require("nookies");
var _constants = require("../constants");
var _authCsr = require("./auth-csr.utils");
var _authSsr = require("./auth-ssr.utils");
const encodeData = data => Object.entries(data).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
exports.encodeData = encodeData;
const setTokens = (data, ctx) => {
  if (data.access_token) {
    _cookie.$cookie.set(_constants.STORAGE_KEYS.AUTH_TOKEN, data.access_token, {
      expires: _constants.AUTH_TOKEN_MAX_AGE
    });
  }
  if (data.refresh_token) {
    _cookie.$cookie.set(_constants.STORAGE_KEYS.REFRESH_TOKEN, data.refresh_token, {
      expires: _constants.REFRESH_TOKEN_MAX_AGE
    });
  }
  if (data.expires_in) {
    // this is in seconds we can use this to refresh the token before we actually hit it
    const expires_in = Date.now() + data.expires_in * 1000;
    _cookie.$cookie.set(_constants.STORAGE_KEYS.TOKEN_EXPIRY, expires_in, {
      expires: _constants.AUTH_TOKEN_MAX_AGE
    });
  }
  if (ctx) {
    if (data.access_token) {
      (0, _nookies.setCookie)(ctx, _constants.STORAGE_KEYS.AUTH_TOKEN, data.access_token, {
        path: '/',
        expires: _constants.AUTH_TOKEN_MAX_AGE
      });
      console.log('setting cookie', _constants.STORAGE_KEYS.AUTH_TOKEN);
    }
    if (data.refresh_token) {
      (0, _nookies.setCookie)(ctx, _constants.STORAGE_KEYS.REFRESH_TOKEN, data.refresh_token, {
        path: '/',
        expires: _constants.REFRESH_TOKEN_MAX_AGE
      });
    }
    if (data.expires_in) {
      const expires_in = Date.now() + data.expires_in * 1000;
      (0, _nookies.setCookie)(ctx, _constants.STORAGE_KEYS.TOKEN_EXPIRY, expires_in, {
        path: '/',
        expires: _constants.AUTH_TOKEN_MAX_AGE
      });
    }
  }
};
exports.setTokens = setTokens;
const clearTokens = ctx => {
  _cookie.$cookie.remove(_constants.STORAGE_KEYS.AUTH_TOKEN);
  _cookie.$cookie.remove(_constants.STORAGE_KEYS.REFRESH_TOKEN);
  _cookie.$cookie.remove(_constants.STORAGE_KEYS.TOKEN_EXPIRY);
  _cookie.$cookie.remove(_constants.STORAGE_KEYS.USER_BASE64);
  if (ctx) {
    (0, _nookies.destroyCookie)(ctx, _constants.STORAGE_KEYS.AUTH_TOKEN);
    (0, _nookies.destroyCookie)(ctx, _constants.STORAGE_KEYS.REFRESH_TOKEN);
    (0, _nookies.destroyCookie)(ctx, _constants.STORAGE_KEYS.TOKEN_EXPIRY);
    (0, _nookies.destroyCookie)(ctx, _constants.STORAGE_KEYS.USER_BASE64);
  }
};
exports.clearTokens = clearTokens;
const getCookie = (ctx, key) => ctx ? (0, _nookies.parseCookies)(ctx)[key] : _cookie.$cookie.get(key);
exports.getCookie = getCookie;
const refreshToken = typeof window !== 'undefined' ? new _authCsr.RefreshTokenCSR() : new _authSsr.RefreshTokenSSR();
exports.refreshToken = refreshToken;